import React from "react"
import ReactDOM from "react-dom"
import Globo from "./Globo"
ReactDOM.render(<Globo />,document.getElementById("root"))